import { localStorageKeys } from 'constants/localStorage';
const skeleton = {
  home: true,
  dashboard: true,
  planosGerais: true,
  relatorios: true,
  geolocalizacao: true,
  almoxarifado: true,
  documentos: {
    exibir: false,
    salvar: false,
  },
  atividadesAgendadas: {
    excluir: false,
    editar: false,
  },
};
const stored = JSON.parse(localStorage.getItem(localStorageKeys.permissionContext));

const initialState = stored || skeleton;

export { initialState, skeleton };
